import { useEffect, useState } from 'react'
import {
  observeAuthenticatedUser,
  type AuthenticatedUser,
} from '@domain/features/user/user-feature'

export function useAuthUser() {
  const [user, setUser] = useState<AuthenticatedUser | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const unsubscribe = observeAuthenticatedUser(
      (nextUser) => {
        setUser(nextUser)
        setLoading(false)
      },
      (err) => {
        setError(err.message)
        setLoading(false)
      },
    )

    return unsubscribe
  }, [])

  return {
    user,
    loading,
    error,
    isAuthenticated: Boolean(user),
  }
}
